import * as messageService from "../../services/message.service";
import * as dealerService from '../../services/dealer.service';


const state = {
    dealerAll:[],
    dealerAllActive:[],
    dealerDropdown:[],
    dealerStaffDropdown:[],
    whichBelongsToDealerManagersDropdown:[],
    dealersBelongsToUserDropdown:[],

    dealerPaginateData:{},
    dealerPaginate:{}
};

const getters = {
    getDealerAll:state => (state.dealerAll),
    getDealerAllActive:state => (state.dealerAllActive),
    getDealerDropdown:state => (state.dealerDropdown),
    getDealerStaffDropdown:state => (state.dealerStaffDropdown),
    getWhichBelongsToDealerManagersDropdown:state => (state.whichBelongsToDealerManagersDropdown),
    getDealersBelongsToUserDropdown:state => (state.dealersBelongsToUserDropdown),

    getDealerPaginateData:state => (state.dealerPaginateData),
    getDealerPaginate:state => (state.dealerPaginate),
};

const actions = {
    async fetchDealerAll({ commit } ){
        try {
            const response = await dealerService.all();
            commit('setDealerAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchDealerAllActive({ commit } ){
        try {
            const response = await dealerService.allActive();
            commit('setDealerAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchDealerDropdown({ commit } ){
        try {
            const response = await dealerService.dropdown();
            commit('setDealerDropdown', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchDealerStaffDropdown({ commit }, dealerId ){
        try {
            const response = await dealerService.staffDropdown(dealerId);
            commit('setDealerStaffDropdown', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    /**
     * 
     * @param {*} param0 
     * @param {*} dealerManagerId 
     */
    async fetchWhichBelongsToDealerManagersDropdown({ commit }, dealerManagerId ){
        try {
            const response = await dealerService.whichBelongsToDealerManagersDropdown(dealerManagerId);
            commit('setWhichBelongsToDealerManagersDropdown', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    /**
     * Get all the dealers which related to user id
     * for dropdown list
     * @param {*} param0 
     * @param {*} userId 
     */
    async fetchDealersBelongsToUserDropdown({ commit }, userId ){
        try {
            const response = await dealerService.dealersBelongsToUserDropdown(userId);
            commit('setDealersBelongsToUserDropdown', response.data);
        } catch (error) {
            console.log('fetchDealersBelongsToUserDropdown - Something wrong', error)

        }
    },

    async fetchDealerPaginate({ commit }, obj){
        commit('setDealerPaginate', obj)
        try {
            const response = await dealerService.listPage(obj);
            commit('setDealerPaginateData', response.data);
            
        } catch (error) {
            console.log('something wrong - fetchDealerPaginate', error);
        }
    },
};

const mutations = {
    setDealerAll:(state, res) => (
        state.dealerAll =  res
    ),
    setDealerAllActive:(state, res) => (
        state.dealerAllActive =  res
    ),
    setDealerDropdown:(state, res) => (
        state.dealerDropdown =  res
    ),
    setDealerStaffDropdown:(state, res) => (
        state.dealerStaffDropdown =  res
    ),
    setWhichBelongsToDealerManagersDropdown:(state, res) => (
        state.whichBelongsToDealerManagersDropdown =  res
    ),
    setDealersBelongsToUserDropdown:(state, res) => (
        state.dealersBelongsToUserDropdown =  res
    ),
    setDealerPaginateData:(state, res) => (
        state.dealerPaginateData =  res
    ),
    setDealerPaginate:(state, res) => (
        state.dealerPaginate =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}